module.exports = __webpack_public_path__ + "img/invalidName@2x.4714312e.png";